<template>
    <v-container fluid>
        <h2>{{ $t('new_banner') }}</h2>
        <banner-form></banner-form>
    </v-container>
</template>

<script>

import BannerForm from '@/components//banner/BannerForm'
import BrowserUtilitiesMixin from '@/components/mixins/BrowserUtilitiesMixin'

export default {
  components: { BannerForm },
  mixins: [BrowserUtilitiesMixin],
  mounted () {
    this.updateBrowserTitle(this.$t('new_banner'))
  }
}

</script>
